<template>
  <div class="border-x border-g3 px-4 mx-4 pt-2 h-[85px]" v-if="attitude_head != null">
    <div class="compassNumber">{{ attitude_head }}°</div>
    <div class="w-[85px] h-[85px] relative overflow-hidden relative top-[-20px]">

      <svg class="w-full absolute" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 254.22 254.22" :style="`transform: rotate(${attitude_head}deg)`">
        <defs>
          <radialGradient id="b" cx="127.08" cy="126.91" fx="127.08" fy="9.64" r="117.27"
            gradientUnits="userSpaceOnUse">
            <stop offset=".01" stop-color="#2e2e2d" />
            <stop offset="1" stop-color="#000" />
          </radialGradient>
        </defs>
        <circle cx="127.08" cy="126.91" r="117.27" style="fill:url(#b); stroke-width:0px;" />
        <path
          d="M238.99,121.48c-2.85-57.2-48.81-103.05-106.05-105.73L127.11,0l-5.85,15.8c-56.62,3.19-101.95,48.62-104.97,105.28L0,127.11l16.3,6.03c3.02,56.67,48.35,102.1,104.97,105.28l5.85,15.8,5.82-15.74c57.25-2.68,103.21-48.53,106.05-105.73l15.23-5.64-15.23-5.64ZM115.04,32.63l-16.87,45.6-38.7-17.72,18.77,37.65-45.12,16.7c5.49-42.73,39.24-76.59,81.92-82.23ZM33.11,139.36l45.12,16.7-17.72,38.71,37.66-18.77,16.87,45.6c-42.68-5.64-76.44-39.5-81.92-82.23ZM127.08,176.63c-27.47,0-49.74-22.27-49.74-49.74,0-27.47,22.27-49.74,49.74-49.74,27.47,0,49.74,22.27,49.74,49.74,0,27.47-22.27,49.74-49.74,49.74ZM139.14,221.73l16.92-45.74,38.17,19.29-18.24-39.23,46.21-17.1c-5.37,43.29-39.74,77.55-83.07,82.77ZM175.99,98.16l19.3-38.18-39.23,18.24-16.92-45.74c43.33,5.22,77.7,39.48,83.07,82.77l-46.21-17.1Z"
          style="fill:#4f4f4f; fill-rule:evenodd; stroke-width:0px;" />
        <circle cx="127.08" cy="126.89" r="45.86" style="fill:#4f4f4f; stroke-width:0px;" />
        <path d="M127.11,15.34c.48,72.28.48,153.37,0,225.65-.48-72.28-.48-153.37,0-225.65h0Z"
          style="fill:#333; stroke-width:0px;" />
        <path d="M206.74,48.54c-50.17,50.84-106.84,107.51-157.68,157.68,50.17-50.84,106.83-107.51,157.68-157.68h0Z"
          style="fill:#333; stroke-width:0px;" />
        <path d="M0,127.11c81.43-.48,172.79-.48,254.22,0-81.43.48-172.79.48-254.22,0h0Z"
          style="fill:#333; stroke-width:0px;" />
        <path d="M205.68,206.73c-50.84-50.17-107.5-106.83-157.67-157.67,50.84,50.17,107.5,106.83,157.67,157.67h0Z"
          style="fill:#333; stroke-width:0px;" />
        <path d="M127.11,0c.48,81.43.48,172.79,0,254.22-.48-81.43-.48-172.79,0-254.22h0Z"
          style="fill:#333; stroke-width:0px;" />
        <path
          d="M122.03,19.59h3.02s3.4,6.49,3.4,6.49l1.29,2.86h.08c-.14-1.38-.38-3.21-.38-4.74v-4.61h2.81v13.04h-3.02s-3.4-6.5-3.4-6.5l-1.29-2.85h-.08c.14,1.44.38,3.19.38,4.72v4.63h-2.81v-13.04Z"
          style="fill:red; stroke-width:0px;" />
        <path
          d="M132.02,223.61l-1.69,2.02c-.93-.81-2.13-1.36-3.2-1.36-1.23,0-1.83.49-1.83,1.26,0,.82.74,1.09,1.88,1.55l1.7.72c1.35.55,2.63,1.66,2.63,3.55,0,2.16-1.93,3.89-4.65,3.89-1.5,0-3.07-.59-4.2-1.71l1.49-1.86c.86.66,1.68,1.02,2.71,1.02s1.66-.42,1.66-1.17c0-.8-.85-1.09-1.99-1.54l-1.66-.67c-1.59-.64-2.59-1.7-2.59-3.55,0-2.17,1.8-4.04,4.91-4.04,1.7,0,3.5.64,4.83,1.89Z"
          style="fill:#fff; stroke-width:0px;" />
        <path d="M235.21,122.7v8.17h-2.47v-5.22s-2.62,0-2.62,0v4.45h-2.47v-4.45s-3.01,0-3.01,0v5.42h-2.47v-8.37h13.04Z"
          style="fill:#fff; stroke-width:0px;" />
        <path
          d="M20.1,134.98v-3.02s6.09-.9,6.09-.9c1.38-.17,2.75-.36,4.12-.53v-.08c-1.38-.25-2.77-.52-4.12-.78l-6.09-1.4v-2.5s6.09-1.4,6.09-1.4c1.33-.26,2.73-.52,4.12-.78v-.08c-1.39-.17-2.78-.35-4.12-.52l-6.09-.9v-2.82s13.04,2.32,13.04,2.32v3.71s-5.92,1.28-5.92,1.28c-1.01.21-2.05.38-3.03.52v.08c.97.16,2.02.32,3.03.53l5.92,1.24v3.64s-13.04,2.42-13.04,2.42Z"
          style="fill:#fff; stroke-width:0px;" />
        <path
          d="M173.39,39.04l1.75-.78c.25.86.7,1.64,1.47,2.09.89.52,1.72.47,2.12-.23.46-.8.28-1.57-1.71-2.72l.87-1.5c1.65.95,2.45.75,2.87.02.37-.65.17-1.25-.55-1.66-.65-.38-1.32-.37-2.18-.19l-.33-1.91c1.26-.24,2.44-.15,3.56.49,1.9,1.1,2.64,2.73,1.71,4.34-.54.94-1.48,1.31-2.7,1.15l-.03.06c.89.91,1.22,2.1.54,3.29-.99,1.71-3.11,1.77-4.95.7-1.48-.86-2.22-1.98-2.45-3.14Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M214.68,72.21c3.43-1.98,6-1.09,7.11.84.7,1.21.7,2.4.44,3.32l-1.92-.39c.17-.52.15-1.27-.16-1.8-.62-1.07-1.91-1.44-4.36-.03-2.28,1.31-2.54,2.42-2.09,3.19.36.63,1.11.9,2.15.3.97-.56,1.04-1.28.64-1.97-.28-.48-.85-.86-1.81-.86l1.33-.9c.97.07,1.87.69,2.21,1.3.91,1.57.69,3.25-1.26,4.37s-3.87.39-4.83-1.28c-1.03-1.78-.68-4.23,2.54-6.09Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M217.63,170.27l-1.16,2,5.3,3.06.99-1.72,1.32.76c-.38,1.09-.51,1.88-.48,2.76l-.9,1.56-7.46-4.3-.99,1.72-1.71-.99,3.37-5.84,1.71.99Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M213.01,177.13c.86,3.61,1.47,6.15,2.79,6.91.89.51,1.66.3,2.12-.51.38-.65.23-1.43,0-2.17l1.81-.49c.44,1.46.44,2.6-.32,3.91-1.04,1.81-2.91,2.37-4.68,1.35-1.54-.89-2.36-3.28-3.04-5.68-.22.5-.54,1.17-.78,1.6l-1.07,1.84-1.78-1.03,3.72-6.45,1.22.7Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M183.88,209.79l-2,1.16,3.06,5.3,1.72-.99.76,1.32c-.88.75-1.38,1.38-1.79,2.15l-1.56.9-4.3-7.46-1.72.99-.99-1.71,5.84-3.37.99,1.71Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M176.59,213.2l-.18,1.89c-.84-.19-1.73-.22-2.51.23-.94.54-1.25,1.39-.71,2.33s1.41,1.08,2.26.59c.53-.31.74-.58,1.09-1.25l1.3.07,2.42,4.77-5.2,3-1.03-1.78,3.37-1.94-.84-1.81c-.26.35-.52.58-.9.8-1.58.91-3.44.79-4.56-1.16s-.28-4.11,1.51-5.14c1.5-.86,2.85-.88,3.98-.58Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M84.72,216.59c-3.61.86-6.16,1.48-6.91,2.79-.51.89-.3,1.66.5,2.13.65.38,1.43.23,2.17,0l.49,1.81c-1.46.44-2.6.44-3.91-.32-1.81-1.04-2.37-2.91-1.35-4.68.89-1.54,3.28-2.36,5.68-3.04-.5-.22-1.17-.54-1.6-.78l-1.84-1.07,1.03-1.78,6.45,3.72-.7,1.22Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M76.34,212.41l-2-1.16-3.06,5.3,1.72.99-.76,1.32c-1.09-.38-1.88-.51-2.76-.48l-1.56-.9,4.3-7.46-1.72-.99.99-1.71,5.84,3.37-.99,1.71Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M43.72,180.72c-2.42-.6-4.9-1.1-6.44-.21-1.77,1.02-2.21,2.92-1.17,4.73.76,1.31,1.74,1.89,3.22,2.23l.48-1.81c-.75-.18-1.5-.44-1.87-1.09-.47-.81-.26-1.58.63-2.09,1.31-.76,3.83-.02,7.38,1.04l1.22-.7-3.72-6.45-1.78,1.03,1.07,1.84c.25.42.67,1.03.99,1.47Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M35.06,170.65l.61,1.06-5.36,3.1,1.5,2.6,7.44.16,1.47-.85-2.29-3.96,2.19-1.26-1.14-1.98-2.19,1.26-.61-1.06-1.62.93ZM37.93,175.62l-2.7-.05c-.67.04-1.33.08-1.98.14l-.03-.06c.6-.31,1.52-.77,2.1-1.1l1.5-.86,1.11,1.93Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M37.56,85.05l-.78-1.75c.86-.25,1.64-.7,2.09-1.47.52-.89.47-1.72-.23-2.12-.8-.46-1.57-.28-2.72,1.71l-1.5-.87c.95-1.65.75-2.45.02-2.87-.65-.37-1.25-.17-1.66.55-.38.65-.37,1.32-.19,2.18l-1.91.33c-.24-1.26-.15-2.44.49-3.56,1.1-1.9,2.73-2.64,4.34-1.71.94.54,1.31,1.48,1.15,2.7l.06.03c.91-.89,2.1-1.22,3.29-.54,1.71.99,1.77,3.11.7,4.95-.86,1.48-1.98,2.22-3.14,2.45Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M38.58,75.19c-3.12-1.8-3.96-4.03-2.82-6s3.5-2.35,6.61-.56c3.12,1.8,4.04,4.08,2.9,6.05s-3.57,2.31-6.69.51ZM41.21,70.63c-2.5-1.44-3.4-1.22-3.81-.5s-.16,1.6,2.34,3.05,3.48,1.27,3.89.55.08-1.65-2.42-3.09Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M70.58,45.69l.2-1.91c.87.21,1.77.21,2.54-.23.89-.52,1.27-1.25.86-1.96-.46-.8-1.22-1.03-3.21.12l-.87-1.5c1.65-.95,1.88-1.75,1.46-2.48-.37-.65-.99-.77-1.71-.36-.65.38-.98.96-1.25,1.79l-1.82-.67c.43-1.21,1.09-2.19,2.21-2.84,1.9-1.1,3.68-.92,4.61.69.54.94.39,1.93-.35,2.92l.03.06c1.23-.31,2.43,0,3.12,1.18.99,1.71-.02,3.57-1.87,4.64-1.48.86-2.83.93-3.95.55Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
        <path
          d="M78.2,41.29l.2-1.91c.87.21,1.77.21,2.54-.23.89-.52,1.27-1.25.86-1.96-.46-.8-1.22-1.03-3.21.12l-.87-1.5c1.65-.95,1.88-1.75,1.46-2.48-.37-.65-.99-.77-1.71-.36-.65.38-.98.96-1.25,1.79l-1.82-.67c.43-1.21,1.09-2.19,2.21-2.84,1.9-1.1,3.68-.92,4.61.69.54.94.39,1.93-.35,2.92l.03.06c1.23-.31,2.43,0,3.12,1.18.99,1.71-.02,3.57-1.87,4.64-1.48.86-2.83.93-3.95.55Z"
          style="fill:#e8e8e8; stroke-width:0px;" />
      </svg>

      <svg class="w-full absolute" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 254.22 254.22">
        <polygon points="127.11 145.72 158.99 161.25 127.11 85.05 95.24 161.25 127.11 145.72"
          style="fill:#fff; fill-rule:evenodd; stroke-width:0px;" />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: "DroneCompass",
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
    };
  },


  mounted() {

  },

  methods: {

  },

  computed: {
    attitude_head() {
      return this.config?.drone?.status?.attitude_head != undefined
        ? this.config.drone.status.attitude_head.toFixed(0)
        : null;
    }
  },
};
</script>
